import {SelectItem} from '@cypro/ui/components/form/select'
import {Ward} from '@cypro/engine/schema'

export function mapWardsToSelectItems(wards: Ward[]): SelectItem[] {
  return wards.map(ward => ({...ward, label: `${ward.code} - ${ward.name}`, value: ward.id}))
}
